module.exports = __webpack_public_path__ + "static/img/index24.678715b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index24.gif
// module id = SlRQ
// module chunks = 0